/** @jsx isolateComponent */

import { cloneElement } from 'react';

import { isolateComponent } from '@zapier/common-utils';

import {
  Interval,
  PlanType,
  trialExtensionReasons,
  TrialType,
} from '@zapier/design-system-revenue/src/types';

import { currentAccount_account_plan as CurrentPlan } from '../hooks/types/currentAccount';
import { planStacks_planStacks_plans as PlanStacksPlan } from '../hooks/types/planStacks';

import { NudgeImage } from '../NudgeImage';
import { UpgradeNudgeLayout } from '../UpgradeNudgeLayout';

import { getActiveView } from './getActiveView';

export type Props = {
  activeTrialType: TrialType | null | undefined;
  currentPlan: CurrentPlan;
  lowestTeamOrCompanyPlan: PlanStacksPlan | null | undefined;
  nextPlan: {
    amount: number;
    interval: Interval;
    name: string;
    tasks: number;
    type: PlanType;
  };
  onClose: () => void;
};

const CloseModalOnClick = ({ children, onClose }: any) =>
  cloneElement(children, {
    onClick: onClose,
  });

export const TaskLimitUpgradeNudge = ({
  activeTrialType,
  currentPlan,
  lowestTeamOrCompanyPlan,
  nextPlan,
  onClose,
}: Props) => {
  const activeView = getActiveView({
    activeTrialType,
    currentPlan,
    lowestTeamOrCompanyPlan,
    nextPlan,
  });

  return (
    <UpgradeNudgeLayout
      bodyText={activeView.bodyText}
      buttons={activeView.buttons.map(button => (
        /**
         * This only needs to exist until we can render the Payment app in web-ssr, as
         * that will allow us to upgrade users inside the modal (thereby eliminating the
         * need to close it) rather than taking them to the plan change page.
         */
        <CloseModalOnClick onClose={onClose}>{button}</CloseModalOnClick>
      ))}
      headingText="You're out of tasks"
      image={<NudgeImage type={trialExtensionReasons.taskLimit} />}
      subtitleText="Heads Up"
    />
  );
};
